import 'slick-carousel';
import $log from './../util/logger';

class IJkelenstamShowroom {
  constructor() {
    $log.debug('IJkelenstamShowroom => constructor');

    this.buildSliders();
  }

  buildSliders() {
    $log.debug('IJkelenstamShowroom => constructor');

    $("[data-slider='showroom']").slick({
      variableWidth: true,
      infinite: true,
      slidesToShow: 2,
    });
  }
}

export default IJkelenstamShowroom;
